var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobile)?_c('mobile-login'):_c('desktop-login')}
var staticRenderFns = []

export { render, staticRenderFns }